const SvgListSelected = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 33 32">
    <path d="M0 0h6.957v6.957H0zm0 12.522h6.957v6.957H0zm0 12.521h6.957V32H0zm9.739-22.26h23.652v1.391H9.739zm0 12.521h23.652v1.391H9.739zm0 12.522h23.652v1.391H9.739z" />
  </svg>;
export default SvgListSelected;